import React, {useEffect, useState} from "react";
import {logCounter, logError} from "../model/utils";
import {lgSetup} from "../../backend/LgSetup";
import {getProfile, saveProfile} from "../../logic_tmp/storage/LgProfile";
import {calcUtmString, getUtmTestParameters} from "../../logic/setup/UtmParser";
import queryString from "query-string";
import {parseParameters} from "../../logic/setup/ParametersParser";
import {assertEqual, assertTrue} from "../../unittests/UnitTestHelper";
import {appdata} from "../../logic_tmp/appdata/AppData";

export function testLgStartLogic() {
    let str = getUtmTestParameters() + "&action=START"
    let params = queryString.parse(str)
    let data = {}
    parseParameters(params, data)
    assertEqual("KOILIN_BELLACIAO", data.currentPath.lmKey)
    let url = lgStartLogic(data)
    assertTrue(url.includes("lm-bellaciao-tln2022-ru"))
    assertTrue(!url.includes("undefined"))
}


export function lgStartLogic(data) {
    if (data.action === undefined)
        throw Error("action in missed")
    let lm = lgSetup["lms"][data.currentPath["lmKey"]]
    let url = lm["lmUrl"] + "?" + calcUtmString(data) + "&cmp=" + data.cmpCode + "&geo=" + data.geoCode + "&setFocusCode=" + data.setFocusCode + "&cmpVersion=" + data.cmpVersion + "&setVersion=" + data.setVersion + "&adKey=" + data.currentPath["adKey"] + "&lmKey=" + data.currentPath["lmKey"] + "&circleKey=" + data.currentPath["circleKey"] + "&action=CIRCLE"
    if (window.location.hostname === "localhost")
        url = url + "&local=true"
    if (!url.includes("http"))
        throw Error("redirect url incorrect: " + url)
    data.viewType = "LeadMagnetPage"
    logCounter("LgStart:" + data.currentPath["adKey"] + "->" + data.currentPath["lmKey"],
        {
            aLocationType: "Start",
            aLocation: data.currentPath["lmKey"],
            bActionType: "IN",
            bAction: "Open",
            cDestinationType: data.currentPath["adKey"],
            cDestination: data.prevViewId,
            zType: "AppTraffic",
            value: 1
        }
    )
    return url
}

export function LgStart() {
    const [isLoading, setLoading] = useState(true);
    useEffect(() => {
        getProfile().firstEntryPath = appdata.currentPath
        saveProfile()
        let url = lgStartLogic(appdata)
        window.location.replace(url)
        setLoading(false)
    }, []);
    return (
        <div>
            {(isLoading) ? <div>Loading...</div> :
                <div>
                    Redirecting...
                </div>
            }
        </div>
    );
}


